import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavbarStatus, NavigationItem } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  @Input() current_nav_item?: NavigationItem;
  @Input() navbar_status?: NavbarStatus;
  @Output() status_change: EventEmitter<NavbarStatus> = new EventEmitter<NavbarStatus>();
  open_navbar_status: NavbarStatus = NavbarStatus.open;
  closed_navbar_status: NavbarStatus = NavbarStatus.closed;

  onStatusChange(): void {
    this.navbar_status = this.navbar_status == NavbarStatus.open ? NavbarStatus.closed : NavbarStatus.open;
    this.status_change.emit(this.navbar_status);
  }
}
